import { render, staticRenderFns } from "./techServices.vue?vue&type=template&id=7ff71611"
import script from "./techServices.vue?vue&type=script&lang=js"
export * from "./techServices.vue?vue&type=script&lang=js"
import style0 from "./techServices.vue?vue&type=style&index=0&id=7ff71611&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports